import { useState } from 'react';
import {
  useResolveConversation,
  useSendMessage,
  useSuggestionQuery,
  useThreadQuery
} from '../../queries/messages';

export function useConversationThread(contactNumber, canSend) {
  const thread = useThreadQuery(contactNumber);
  const messages = thread.data?.messages || [];
  const last = messages[messages.length - 1];
  const awaitingReply = last?.direction === 'inbound';

  const [dismissedId, setDismissedId] = useState(null);
  const wantsSuggestion = Boolean(canSend && awaitingReply && last?._id !== dismissedId);
  const suggestionQuery = useSuggestionQuery(contactNumber, last?._id, wantsSuggestion);

  const send = useSendMessage();
  const resolve = useResolveConversation();

  return {
    messages,
    loading: thread.isLoading,
    awaitingReply,
    suggestion: wantsSuggestion && suggestionQuery.data?.suggestion ? suggestionQuery.data : null,
    suggestionLoading: wantsSuggestion && suggestionQuery.isLoading,
    dismissSuggestion: () => setDismissedId(last?._id),
    send: (body, options) => send.mutate({ contactNumber, body }, options),
    sending: send.isPending,
    resolve: () => resolve.mutate(contactNumber),
    resolving: resolve.isPending
  };
}
